module.exports = __webpack_public_path__ + "img/2.2348c8e1.png";